import router from "@/router";
import axios from "axios";

const YHtance = axios.create({
  // baseURL: "http://localhost",
  baseURL: 'https://spapi.wearehpr.cn'
});

// 请求拦截器
YHtance.interceptors.request.use(
  (req) => {
    return req;
  },
  (err) => {
    return Promise.reject(err);
  }
);

YHtance.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export default YHtance;